import styles from "./HeroSection.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useTranslation } from "react-i18next";
import NewBanner1 from "../../../../assets/images/hero/NewBanner1.jpg";
import NewBanner2 from "../../../../assets/images/hero/NewBanner2.jpg";
import NewBanner3 from "../../../../assets/images/hero/NewBanner3.jpg";

const HeroSection = () => {
  const { t } = useTranslation("translation");

  return (
    <div className={styles.hero_section}>
      <div className="container">
        {/* Hero Content */}
        <div className={styles.hero_content}>
          {/* Main Banner Slider */}
          <div className={styles.main_banner}>
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 5000 }}
              loop={true}
              speed={1000}
              slidesPerView={1}
              className={styles.banner_slider}
            >
              <SwiperSlide className={styles.banner_slide}>
                <img src={NewBanner1} alt="banner" />
                <div className={styles.banner_overlay}>
                  <h2>
                    {t("hero_title") ||
                      "İndi onlayn mağazamızla sonsuz imkanları kəşf edin və ehtiyacınız olan hər şeyi bir yerdə rahatlıqla tapın!"}
                  </h2>
                </div>
              </SwiperSlide>
              <SwiperSlide className={styles.banner_slide}>
                <img src={NewBanner1} alt="banner" />
                <div className={styles.banner_overlay}>
                  <h2>
                    {t("hero_title") ||
                      "İndi onlayn mağazamızla sonsuz imkanları kəşf edin və ehtiyacınız olan hər şeyi bir yerdə rahatlıqla tapın!"}
                  </h2>
                </div>
              </SwiperSlide>
              <SwiperSlide className={styles.banner_slide}>
                <img src={NewBanner1} alt="banner" />
                <div className={styles.banner_overlay}>
                  <h2>
                    {t("hero_title") ||
                      "İndi onlayn mağazamızla sonsuz imkanları kəşf edin və ehtiyacınız olan hər şeyi bir yerdə rahatlıqla tapın!"}
                  </h2>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          {/* Side Banners */}
          <div className={styles.side_banners}>
            <div className={styles.side_banner}>
              <img src={NewBanner2} alt="watch banner" />
            </div>
            <div className={styles.side_banner}>
              <img src={NewBanner3} alt="bag banner" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
